<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <ToggleMenuBar v-model="state.menu" :first-menu="'축하하기'" :second-menu="'둘러보기'" />

            <SmileEmoticonCard
              :items="FUNERAL_BUY_LIST"
              :selected="state.index"
              :menu="state.menu"
              :is-notice="true"
              v-if="state.menu === EMOTICON_MENU.SMILE"
              @click="fnEmojiPick"
            />

            <SmileEmoticonCard
              :items="FUNERAL_EMOTICON_LIST"
              :selected="state.index"
              :menu="state.menu"
              :is-notice="true"
              v-if="state.menu === EMOTICON_MENU.WATCH"
              @click="fnEmojiPick"
            />
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn border-gray" @click="close">닫기</button>
              <button class="btn" @click="fnFetch" v-if="state.menu === EMOTICON_MENU.SMILE">선택</button>
              <button class="btn" @click="fnEmojiBuy" v-if="state.menu === EMOTICON_MENU.WATCH">선택</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onBeforeMount, reactive, watch } from 'vue';
import { EMOTICON_MENU, FUNERAL_BUY_LIST, FUNERAL_EMOTICON_LIST } from '@/common/constants/ConstCode';
import { purchaseCall } from '@/common/utils/module/NativeRequest';
import store from '@/store';
import { modalList, show, showTextModal } from '@/common/utils/ModalState';

import ToggleMenuBar from '@/components/common/layouts/ToggleMenuBar.vue';
import { isApp } from '@/common/utils/module/IsMobileSupport';
import { useRoute } from 'vue-router';
import SmileEmoticonCard from '@/components/common/smile/SmileEmoticonCard.vue';
import { fnShowIsAppPurchaseModal } from '@/common/utils/Util';

const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, smileNo } = props.data;
const { params } = useRoute();

onBeforeMount(async () => {
  fnEmojiPick(FUNERAL_BUY_LIST?.value[0]);
});

const state = reactive({
  emoticon: '',
  smileNo: smileNo,
  itemHistoryNo: '',
  emoticonNo: '',
  index: 0,
  menu: EMOTICON_MENU.SMILE,
  list: FUNERAL_BUY_LIST
});
watch(
  () => state.menu,
  newValue => {
    newValue === EMOTICON_MENU.WATCH
      ? fnEmojiPick(FUNERAL_EMOTICON_LIST?.value[0])
      : fnEmojiPick(FUNERAL_BUY_LIST?.value[0]);
  }
);

const fnEmojiPick = (item, index = 0) => {
  state.emoticon = item?.file?.storedFileName;
  state.emoticonNo = item?.productNo;
  state.itemHistoryNo = item?.itemHistoryNo;
  state.index = index;
};

const fnEmojiBuy = () => {
  store.commit('user/setPurchase', '');

  show(modalList.CONFIRM, {
    contents: '해당 이모티콘을 구매하시겠습니까?',
    doneText: '구매',
    cancelText: '취소',
    doneCallback: async () => {
      const result = FUNERAL_EMOTICON_LIST.value.filter(emoticon => emoticon.productNo === state.emoticonNo);
      const purchase = {
        price: result[0].price,
        productCode: result[0].productCode,
        category: 'EMOTICON',
        productNo: state.emoticonNo,
        useTargetNo: state.smileNo,
        productId: result[0].productId
      };
      store.commit('user/setPurchase', purchase);
      store.commit('user/setPurchaseCallBack', purchaseCallBack);
      if (isApp()) {
        purchaseCall(purchase.productId);
      } else {
        fnShowIsAppPurchaseModal();
        return false;
      }
    }
  });
};

const purchaseCallBack = async () => {
  await store.dispatch('emoticon/buyEmoticon', state);
  await store.dispatch('emoticon/getSmileEmoticonList', state.smileNo);
  fnEmojiPick(FUNERAL_EMOTICON_LIST?.value[0]);
};

const fnFetch = () => {
  if (fnCallBack) fnCallBack(state);
  setTimeout(() => {
    emits('close');
  }, 200);
};
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
